export const blockIconsPhotoandimagePictureAsPdfNew = (
	<span className='material-symbols-outlined'>picture_as_pdf</span>
);
